module.exports = __webpack_public_path__ + "img/add_signature.2af23448.svg";